import React from 'react';
export default function HeartGlassesSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 18C4 14 7 12 10 14L11 15L12 14C15 12 18 14 18 18C18 22 11 28 11 28C11 28 4 22 4 18Z" fill="#E91E63" />
      <path d="M22 18C22 14 25 12 28 14L29 15L30 14C33 12 36 14 36 18C36 22 29 28 29 28C29 28 22 22 22 18Z" fill="#E91E63" />
      <rect x="18" y="19" width="4" height="2" rx="1" fill="#C2185B" />
    </svg>
  );
}
